<template>
  <div @click="clickItem" class="item">
    <img :src="iconUrl" class="icon" />
  </div>
</template>

<script>
export default {
  props: {
    // 是否选中
    isChecked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 是否暗黑
    isDark() {
      return this.mix_system.systemInfo.theme === 'dark';
    },
    iconUrl() {
      return this.isChecked
        ? 'https://j5.dfcfw.com/imagesystem/lowcode_imgs/b6ca48956fbf2c30af383b6047519f83.png'
        : 'https://j5.dfcfw.com/imagesystem/lowcode_imgs/78d027c2a647e75f9f0340e3bf977be1.png';
    },
  },
  methods: {
    // 点击事件
    clickItem() {
      this.$emit('clickItem', !this.isChecked);
    },
  },
};
</script>

<style>
.item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.icon {
  width: 34px;
  height: 34px;
  margin-right: 8px;
}
</style>
